
import HomeSections from './HomeSections.vue';
export default {
    name: 'HomeComponent',
    components: {
        HomeSections,
    }
}
